import { Text } from "react-native";

import { IconProps, IconVariantMap } from "./Icon.types";
import { useClassNames, useTheme } from "../../../structure";

export default function Icon({ name, variant = "outlined", size, color, onPress, disabled, classNames }: IconProps) {
  const style = useClassNames(classNames || []);
  const { theme } = useTheme();
  return (
    <Text
      onPress={onPress}
      style={{
        fontFamily: IconVariantMap[variant],
        fontSize: size || theme.fonts.baseSize,
        color: color || theme.colors.primary.main,
        ...style,
      }}
      disabled={disabled}
    >
      {name}
    </Text>
  );
}
